import React from 'react';

const notes = [
  {
    title: 'Meeting Notes',
    text: 'Discussed Q1 earnings outlook and revised price target assumptions based on...',
    pinned: true,
  },
  {
    title: 'Research Summary',
    text: 'Competitive landscape analysis shows market share gains accelerating in key...',
  },
  {
    title: 'Action Items',
    text: 'Follow up on management guidance revision and updated DCF model with new...',
  },
];

const Preview: React.FC = () => (
  <div className="h-full bg-surface flex flex-col overflow-hidden">
    {/* Header */}
    <div className="px-3 py-2 border-b bg-neutral-50 flex items-center justify-between gap-2">
      <div className="flex-1">
        <div className="h-5 bg-surface border border-neutral-200 rounded text-[8px] text-neutral-400 px-1.5 flex items-center">
          Search...
        </div>
      </div>
      <div className="text-[8px] text-neutral-500 flex-shrink-0">3 notes</div>
      <div className="h-5 px-1.5 bg-primary-600 text-white text-[8px] rounded flex items-center gap-0.5 flex-shrink-0">
        <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        New Note
      </div>
    </div>

    {/* Notes grid */}
    <div className="flex-1 overflow-hidden p-2">
      <div className="grid grid-cols-2 gap-1.5">
        {notes.map(n => (
          <div key={n.title} className="rounded border border-neutral-200 p-2 bg-surface">
            <div className="flex items-start justify-between gap-1">
              <div className="text-[9px] font-medium text-neutral-900 truncate">{n.title}</div>
              {n.pinned && (
                <svg className="w-2.5 h-2.5 text-warning-500 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z" />
                </svg>
              )}
            </div>
            <div className="text-[8px] text-neutral-500 leading-relaxed mt-0.5 line-clamp-2">{n.text}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Preview;
